
/**
 * 
 * @param {string} employeeName
 * @param {string} employeeImageUrl
 * @param {string} officeName
 * @param {string} cardSize [optional]
 */
function SelectedEmployee(props){
    const elementId = "selectedEmployee-" + props.employeeName.split(" ").map(item => item.trim());
	const selectedEmployeeId = elementId.replace(/,/g, "-");
	

    return(
        <div className="book-meeting__textwrapper">
			<label htmlFor={selectedEmployeeId}>Du har valgt:</label>
			<div className="book-meeting__advisor-card">
				<div className="book-meeting__advisor-wrapper" id={selectedEmployeeId}>
					<img className="book-meeting__advisor-img" 
						src={props.employeeImageUrl} 
						alt={"bilde av " + props.employeeName} 
					/>	
					<div className="book-meeting__content">
						<h3 className="book-meeting__advisor-name">{props.employeeName}</h3>                
						<p className="book-meeting__advisor-title">{props.officeName}</p>                              
					</div>
				</div>		
			</div>
		</div>
    )
}
export default SelectedEmployee;